/**
 * 内置辅助函数
 */
export const builtInHelpers = {
  /**
   * 格式化距离
   * @param {number} meters - 距离（米）
   * @returns {string} 格式化后的距离文本
   */
  formatDistance(meters) {
    if (meters < 1000) {
      return `${Math.round(meters)}米`;
    }
    return `${(meters / 1000).toFixed(1)}公里`;
  },

  /**
   * 格式化距离（英文）
   * @param {number} meters - 距离（米）
   * @returns {string} 格式化后的距离文本
   */
  formatDistanceEn(meters) {
    if (meters < 1000) {
      return `${Math.round(meters)}m`;
    }
    return `${(meters / 1000).toFixed(1)}km`;
  },

  /**
   * 将数组格式化为中文列表
   * @param {string[]} items - 数组
   * @returns {string} "A、B、C"
   */
  joinList(items) {
    if (!Array.isArray(items)) return '';
    return items.join('、');
  },

  /**
   * 将数组格式化为英文列表
   * @param {string[]} items - 数组
   * @returns {string} "A, B, C"
   */
  joinListEn(items) {
    if (!Array.isArray(items)) return '';
    return items.join(', ');
  },

  /**
   * 根据五行返回对应颜色
   * @param {string} element - 五行名称
   * @returns {string} CSS 颜色值
   */
  elementColor(element) {
    const colors = {
      木: '#4CAF50',
      火: '#F44336',
      土: '#795548',
      金: '#FFC107',
      水: '#2196F3',
    };
    return colors[element] || '#999';
  },

  /**
   * 条件判断辅助：如果距离在范围内
   * @param {number} distance - 距离
   * @param {number} threshold - 阈值
   * @returns {boolean}
   */
  isWithinRange(distance, threshold) {
    return distance <= threshold;
  },
};
